import { render, staticRenderFns } from "./ReportCentre.vue?vue&type=template&id=35046849&scoped=true"
import script from "./ReportCentre.vue?vue&type=script&lang=js"
export * from "./ReportCentre.vue?vue&type=script&lang=js"
import style0 from "./ReportCentre.vue?vue&type=style&index=0&id=35046849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35046849",
  null
  
)

export default component.exports